export const KABAS = [
  {
    id: "burgundy-beaded",
    no: "01",
    name: "Crimson Cape",
    line: "Burgundy velvet · folded lapel collar · crystal & bead appliqué",
    text: "Deep burgundy velvet with a soft folded lapel and hand-placed crystal and bead florals sweeping over both shoulders — made for evenings, weddings and every room you walk into.",
    image: "/images/real/hero_crimson_suit.jpg",
    alt: "Woman wearing the Crimson Cape over a grey pantsuit with a grey handbag",
    gallery: [
      { src: "/images/real/crimson_walk.jpg", label: "Out & about", alt: "Woman walking in the Crimson Cape with burgundy leggings and boots" },
      { src: "/images/real/crimson_pink.jpg", label: "Evening elegance", alt: "Woman in the Crimson Cape over a burgundy mermaid skirt with a matching handbag" },
      { src: "/images/real/red_worn_2.jpg", label: "Styled for evening", alt: "Woman in the burgundy kaba over a cream satin dress at an evening event" },
      { src: "/images/real/closet_red.jpg", label: "In the closet", alt: "The Crimson Cape kaba hanging in a wooden closet" },
      { src: "/images/real/burgundy_photo.jpg", label: "The real piece", alt: "Photo of the actual Crimson Cape kaba on a hanger" },
    ],
  },
  {
    id: "navy-gold",
    no: "02",
    name: "Midnight Majesty",
    line: "Navy velvet · mandarin collar · gold scroll embroidery · brass buttons",
    text: "Royal navy velvet with a high mandarin collar, two antique brass buttons and gold scrollwork tracing the neck and front — regal enough for ceremony, sharp enough for the city.",
    image: "/images/real/navy_worn.jpg",
    alt: "Woman wearing the navy velvet kaba with gold scroll embroidery on a city street",
    gallery: [
      { src: "/images/real/navy_portrait.jpg", label: "Portrait", alt: "Woman in the Midnight Majesty cape showing the gold scroll collar and brass button" },
      { src: "/images/real/closet_navy.jpg", label: "In the closet", alt: "The Midnight Majesty kaba hanging in a wooden closet" },
      { src: "/images/real/navy_photo.jpg", label: "The real piece", alt: "Photo of the actual Midnight Majesty kaba on a hanger" },
    ],
  },
  {
    id: "black-crystal",
    no: "03",
    name: "Black Mamba",
    line: "Black velvet · lapel collar · crystal fringe falling from both shoulders",
    text: "Midnight-black velvet crowned with crystal teardrops and short rhinestone fringe that fall down the sides of each shoulder — pure drama for galas, weddings and nights out.",
    image: "/images/real/black_pants.jpg",
    alt: "Woman wearing the Black Mamba velvet kaba with crystal fringe shoulders over a white blouse and black trousers",
    gallery: [
      { src: "/images/real/black_bwdress.jpg", label: "With a black & white dress", alt: "Woman in the Black Mamba kaba over a knee-length black and white dress" },
      { src: "/images/real/black_reddress.jpg", label: "With a red dress", alt: "Woman in the Black Mamba kaba over a red satin gown at a gala" },
      { src: "/images/real/closet_black.jpg", label: "In the closet", alt: "The Black Mamba kaba hanging in a wooden closet" },
      { src: "/images/real/black_photo.jpg", label: "The real piece", alt: "Photo of the actual Black Mamba kaba on a hanger" },
    ],
  },
];

export const KABA_OPTIONS = [
  ...KABAS.map(({ id, name }) => ({ id, name })),
  { id: "bespoke", name: "Bespoke — design my own" },
];

export const PRICE = "$125";
export const FIT = "One size fits all · XS\u2060–\u20602XL · waist length";
